import { useLocation } from 'react-router-dom';
import { useRequestSelectiveProcessVacancy } from '../../../../../services/hooks/SelectiveProcess/useRequestSelectiveProcessVacancy';
import { useFormContext } from 'react-hook-form';
import { Flex, FormLabel, Stack, Switch } from '@chakra-ui/react';
import InputSelectMobile from '../../../../../components/Input/Mobile/Select';
import { IDataToRegistration } from '../../../../../services/hooks/CandidateArea/useGetDataToRegistration';
import { FaGraduationCap } from 'react-icons/fa';
import { useMemo } from 'react';
import { IoHomeSharp } from 'react-icons/io5';

interface IOwnProps {
  selectiveProcess?: IDataToRegistration;
}

const FormCultureHouseMobilePage: React.FC<IOwnProps> = ({ selectiveProcess }) => {
  const { watch, register, setValue } = useFormContext();
  const selectiveProcessId = useLocation().pathname.split('/')[2];
  const isCultureHouse = selectiveProcess?.is_cultural_house || false;
  const cultureHouse = selectiveProcess?.cultural_houses || [];
  const accent = '#222';

  const vacancy = useRequestSelectiveProcessVacancy(selectiveProcessId, isCultureHouse, watch('culture_home'));

  const secondVacancy = useRequestSelectiveProcessVacancy(
    selectiveProcessId,
    isCultureHouse,
    watch('culture_home_secondary'),
  );

  const listVacancy = useMemo(() => {
    if (vacancy.data) {
      return vacancy?.data?.filter((vacancy) => vacancy.id !== watch('initial_semester_secondary'));
    }

    return [];
  }, [vacancy.data, watch('initial_semester_secondary')]);

  const listSecondVacancy = useMemo(() => {
    if (secondVacancy.data) {
      return secondVacancy?.data?.filter((vacancy) => vacancy.id !== watch('vacancy'));
    }

    return [];
  }, [secondVacancy.data, watch('vacancy'), watch('culture_home_secondary')]);

  return (
    <Stack w="full" gap={3} mt={1}>
      <InputSelectMobile
        name="culture_home"
        placeholderLabel="Selecione a casa de cultura desejada"
        iconLeft={<IoHomeSharp size={13} color={accent} />}
        onChangeItem={() => {
          setValue('vacancy', '', { shouldDirty: true });
        }}
        isRequired
        listItens={cultureHouse}
      />
      <InputSelectMobile
        name="vacancy"
        placeholderLabel="Turma"
        isDisabled={!watch('culture_home') || vacancy.isFetching || !listVacancy.length}
        iconLeft={<FaGraduationCap size={15} color={accent} />}
        isRequired
        listItens={listVacancy}
      />
      {selectiveProcess?.allow_second_registration && (
        <Flex gap={2}>
          <Switch
            isChecked={watch('has_second_vacancy')}
            {...register('has_second_vacancy')}
            size="md"
            fontSize="sm"
            isRequired={false}
            id="second-vacancy"
            colorScheme="green"
          />
          <FormLabel fontSize="sm" fontWeight="normal" htmlFor="second-vacancy">
            Você deseja informar uma segunda opção
          </FormLabel>
        </Flex>
      )}
      {watch('has_second_vacancy') && (
        <Stack>
          <InputSelectMobile
            name="culture_home_secondary"
            onChangeItem={() => setValue('initial_semester_secondary', '', { shouldDirty: true })}
            placeholderLabel="Selecione a casa de cultura"
            iconLeft={<IoHomeSharp size={13} color={accent} />}
            isRequired
            listItens={cultureHouse}
          />
          <InputSelectMobile
            name="initial_semester_secondary"
            placeholderLabel="Turma"
            isDisabled={!watch('culture_home_secondary') || secondVacancy.isFetching || !listSecondVacancy.length}
            iconLeft={<FaGraduationCap size={15} color={accent} />}
            isRequired
            listItens={listSecondVacancy}
          />
        </Stack>
      )}
    </Stack>
  );
};

export default FormCultureHouseMobilePage;
